export default {
  DEPOSITS: "Deposits",
  DEPOSIT: "Deposit",
  APP_NAME: "WISE Manager",
  EMAIL: "Email",
  PASSWORD: "Password",
  SIGN_IN: "Sign In",
  FORGOT_PASSWORD: "Forgot Password?",
  PAGE_NOT_FOUND: "Requested Page Not Found",
  RETURN_HOME: "Return to Home",
  WELCOME: "Welcome",
  MY_PROFILE: "My Profile",
  LOGOUT: "Logout",
  DASHBOARD: "Dashboard",
  USERS: "Users",
  ROLES: "Roles",
  ORGANIZATIONS: "Organizations",
  ORGANIZATION: "Organization",
  PRODUCTS: "Products",
  PRODUCT: "Product",
  ALL: "All",
  NAME: "Name",
  ADDRESS: "Address",
  PHONE: "Phone",
  CREATED_AT: "Created At",
  SEARCH: "Search",
  NO_RESULTS: "No results found",
  PER_PAGE: "Per Page",
  PAGINATION: "Pagination",
  VIEW: "View",
  EDIT: "Edit",
  DELETE: "Delete",
  DISPLAY_FROM_X_TO_X_OF_X_ENTRIES: "Displaying {from} to {to} of {of} entries",
  X_LINES_SELECTED: "{count} selected lines",
  RETURN_TO_LIST: "Return to List",
  SELECT_IMAGE: "Select Image",
  CHANGE_IMAGE: "Change Image",
  REMOVE_IMAGE: "Remove Image",
  ROLE: "Role",
  FIRSTNAME: "First Name",
  LASTNAME: "Last Name",
  CONFIRM_PASSWORD: "Confirm Password",
  RESELLERS: "Resellers",
  RESELLER: "Reseller",
  LOCALE: "Locale",
  LOCALE_FR: "French",
  LOCALE_EN: "English",
  GLOBAL: "Global",
  NONE: "None",
  UPDATED_AT: "Updated At",
  PERMISSIONS: "Permissions",
  ALL_ORGANIZATIONS: "All Organizations",
  ALL_RESELLERS: "All Resellers",
  ALL_ROLES: "All Roles",
  ALL_USERS: "All Users",
  ALL_PRODUCTS: "All Products",
  EXCERPT: "Description",
  OWNER: "Owner",
  USER: "User",
  YES: "Yes",
  NO: "No",
  OK: "OK",
  PICTURE: "Picture",
  GALLERY: "Gallery",
  TAXES: "Taxes",
  ORDER_ITEM_TAX_GROUPS: "Applicable line taxes",
  PRICE: "Price",
  RATE: "Rate (%)",
  CODE: "Code",
  DEFAULT_TAXES: "Default Taxes",
  INVOICES: "Invoices",
  INVOICE: "Invoice",
  RECIPIENT: "Recipient",
  COUNTRY: "Country",
  COUNTRIES: "Countries",
  STATES: "States",
  STATE: "State",
  CITY: "City",
  ZIPCODE: "Zipcode",
  NOTE: "Note",
  STATUS: "Status",
  ALL_STATUSES: "All statuses",
  CLIENT_VALIDATION_STATUS: "Customer validation status",
  AMOUNT: "Amount",
  REFERENCE_DATE: "Reference date",
  DAYS_LATE: "Days late",
  PURCHASES_LATE_WIDGET_TITLE: "Purchase orders awaiting invoicing",
  PURCHASES_LATE_WIDGET_EMPTY: "All purchase orders are up to date.",
  SALES_LATE_WIDGET_TITLE: "Sales orders awaiting customer validation",
  SALES_LATE_WIDGET_EMPTY: "All sales orders are validated by customers.",
  PAIED: "Paid",
  TOTAL: "Total",
  TOTAL_PAIED: "Total paid",
  SOURCE: "Source",
  BASE: "Base",
  RATE: "Rate",
  RENT_PART: "Rent share",
  CREATED_BY: "Created by",
  DETAILS: "Details",
  PAYMENTS: "Payments",
  UNIT_PRICE: "Unit price",
  SUBTOTAL: "Subtotal",
  QUANTITY: "Quantity",
  DISCOUNT: "Discount",
  REMAINING_PAYMENT_AMOUNT: "Remaining payment amount",
  DISCOUNT_PERCENT: "Discount (%)",
  CLOSE: "Close",
  CUSTOMER: "Customer",
  CUSTOMERS: "Customers",
  LOGS: "Logs",
  CAUSER: "Causer",
  DATE: "Date",
  GO_BACK: "Go back",
  PACKAGE: "Package",
  PACKAGES: "Packages",
  ALL_PACKAGES: "All packages",
  ALL_TYPES: "All types",
  SUBSCRIPTION: "Subscription",
  SUBSCRIPTIONS: "Subscriptions",
  TYPE: "Type",
  TAX_TYPE_PERCENTAGE: "Percentage",
  TAX_TYPE_AMOUNT: "Amount",
  PAYMENT: "Payment",
  ALL_INVOICES: "All invoices",
  DISCOUNTS: "Discounts",
  DISCARD_CHANGES_AND_LEAVE_PAGE: "Discard changes and leave page?",
  COMPANY_NAME: "Company name",
  BILLING_ENTITY_TYPE_INDIVIDUAL: "Individual",
  BILLING_ENTITY_TYPE_COMPANY: "Company",
  CONTACTS: "Contacts",
  CONTACT: "Contact",
  SUPPLIER: "Supplier",
  SCHOOL: "School",
  TITLE: "Title",
  TITLES: "Titles",
  ALL_TITLES: "All titles",
  TITLE_MR: "Mister",
  TITLE_MDM: "Madam",
  TAGS: "Tags",
  BIRTHDAY: "Birthday",
  SUPPLIERS: "Suppliers",
  FISCAL_NUMBER: "Fiscal number",
  UPDATE: "Update",
  UPDATED: "Updated",
  COLOR: "Color",
  LINK_CONTACT: "Link contact",
  ADD_CONTACT: "Add contact",
  SOURCE: "Source",
  LOCATIONS: "Locations",
  LOCATION: "Location",
  ALL_LOCATIONS: "All locations",
  FILES: "Files",
  TRAININGS: "Trainings",
  TRAINING: "Training",
  FILE: "File",
  ALL_FILES: "All files",
  FOLDERS: "Folders",
  FOLDER: "Folder",
  ALL_FOLDERS: "All folders",
  FILES_EXPLORER: "Explorer",
  CAFETERIAS: "Cafeterias",
  CAFETERIA: "Cafeteria",
  CUSTOMER_NUMBER: "Customer number",
  ESTABLISHMENTS: "Establishments",
  ESTABLISHMENT: "Establishment",
  SERVICECENTERS: "Service centers",
  SERVICECENTER: "Service center",
  IMPORTS: "Imports",
  IMPORT: "Import",
  NEXT_STEP: "Next step",
  PREV_STEP: "Previous step",
  CANCEL: "Cancel",
  DOWNLOAD_CSV_FILE: "Download csv file",
  SUPPLY_RULES: "Supply rules",
  UPCOMING_PURCHASE: "Upcoming purchase",
  SEE_MORE: "See more",
  FOLD_WIDGET: "Fold",
  UNFOLD_WIDGET: "Unfold",
  CATEGORY: "Category",
  COPY: "Copy",
  MOVEMENT_DATE: "Movement Date",
  BULK_SET: "Bulk Set",
  RESET: "Reset",
  SEARCH_PLACEHOLDER: "Search...",
  SELECT_OPTION: "Select an option",
  DATES_PLACEHOLDER: "Dates",
  INTERNAL_INVOICE: "Internal invoice",
  INTERNAL_INVOICES: "Internal invoices",
  EXPECTED_DELIVERY_DATE: "Expected Delivery Date",
  VALIDATED_AT: "Validated At",
  WRITE_YOUR_COMMENT: "Write your comment",
  NAME_ON_CARD: "Name on card",
  CARD_NUMBER: "Card number",
  CCV: "CCV",
  SAVE_NEW_CARD: "Save new card",
  SELECT_A_COLUMN: "Select a column",
  PROJECT: "Project",
  BUDGET: "Budget",
  USERS_LABEL: "Users",
  PAGE_VISITS: "Page visits",
  VISITORS: "Visitors",
  UNIQUE_USERS: "Unique users",
  BOUNCE_RATE: "Bounce rate",
  SOCIAL_TRAFFIC: "Social traffic",
  REFERRAL: "Referral",
  SEE_ALL: "See all",
  LIGHT_TABLE: "Light table",
  COMPLETION: "Completion",
  ACTIONS: "Actions",
  READ: "Read",
  ALL_CUSTOMERS: "All customers",
  ALL_RECIPIENTS: "All recipients",
  ALL_CONTACTS: "All contacts",
  INFO: "Info",
  WARNING: "Warning",
  ALL_TAXES: "All taxes",
  ALL_UNIT_OF_MEASURES: "All units of measure",
  RESELLER_INVOICE: "Reseller invoice",
  RESELLER_ORDER: "Reseller order",
  SUCCESS_VERIFICATION: "Verification succeeded",
  ERROR_VERIFICATION: "Verification failed",
  VERIFICATION_CODE: "Verification Code",
  RESEND_CODE: "Resend Code",
  CANCEL: "Cancel",
  REMEMBER_ME: "Remember me for 12 hours",
  SAVED: "Saved",
  SAVE_AND_LEAVE: "Save and leave",
  LEAVE_WITHOUT_SAVING: "Leave without saving",
  UNSAVED_CHANGES_WARNING: "You have unsaved changes. Do you want to leave?",
  DOWNLOAD: "Download",
  DOWNLOADING: "Downloading",
  DOWNLOAD_FAILED: "Download failed",
  UNIT: "Unit",
  ALL_PAYMENT_TERMS: "All payment terms",
  PRODUCTS_REPORT: "Products Report",
  POS_PRODUCTS_REPORT: "Products sold (POS)",
  WEEKLY_REPORTS_REPORT: "Weekly Report",
  BY_WAREHOUSE: "By warehouse",
  DOCUMENT_TYPES: "Document Types",
  PRODUCT_SEARCH: "Search Product",
  APPLY_FILTERS: "Apply Filters",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  SKU: "SKU",
  PURCHASES: "Purchases",
  SALES: "Sales",
  SALES_PRICING: "Sales Pricing",
  CUSTOM_PRICE: "Custom price",
  SUBSIDIZED_PRICE: "Subsidized Price",
  CATERER_PRICE: "Caterer Price",
  TRANSFERS: "Transfers",
  TRANSFERS_INCOMING: "Incoming Transfers",
  TRANSFERS_OUTGOING: "Outgoing Transfers",
  INTERNAL_INVOICES: "Internal Invoices",
  INTERNAL_INVOICES_INCOMING: "Incoming Internal Invoices",
  INTERNAL_INVOICES_OUTGOING: "Outgoing Internal Invoices",
  ESTABLISHMENT_TRANSFERS_INCOMING: "Incoming Transfers",
  ESTABLISHMENT_TRANSFERS_OUTGOING: "Outgoing Transfers",
  ESTABLISHMENT_INTERNAL_INVOICES_INCOMING: "Incoming Internal Invoices",
  ESTABLISHMENT_INTERNAL_INVOICES_OUTGOING: "Outgoing Internal Invoices",
  ESTABLISHMENT_INTERNAL_ORDERS: "Internal Orders",
  SALES_ORDERS_STANDARD: "Sales Invoices - Standard",
  SALES_ORDERS_SUBSIDIZED: "Sales Invoices - Subsidized",
  SALES_ORDERS_CATERER: "Sales Invoices - Caterer",
  QUANTITY: "Quantity",
  AMOUNT: "Amount",
  CODE: "Code",
  RESET: "Reset",
  TOTAL_PRODUCTS: "Total Products",
  TOTAL_SALES: "Total Sales",
  TOTAL_PURCHASES: "Total Purchases",
  TOTAL_TRANSFERS_INCOMING: "Total Incoming Transfers",
  TOTAL_TRANSFERS_OUTGOING: "Total Outgoing Transfers",
  TOTAL_INTERNAL_INVOICES_INCOMING: "Total Incoming Internal Invoices",
  TOTAL_INTERNAL_INVOICES_OUTGOING: "Total Outgoing Internal Invoices",
  DATE_RANGE: "Date Range",
  DATES_PLACEHOLDER: "Select date range",
  UNITS: "units",
  TOTALS: "Totals",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  NO_DATA: "No data",
  TRANSACTIONS: "Transactions",
  TOTAL_AMOUNT: "Total Amount",
  PAYMENT_TYPES: "Payment Types",
  CASH: "Cash",
  CARD: "Card",
  PREPAID_CARD: "Prepaid Card",
  CASHIER: "Cashier",
  SELECT_ALL: "Select all",
  UN_SELECT_ALL: "Unselect all",
  EXPORT_EXCEL: "Export to Excel",
  RECALCULATE: "Recalculate",
  RECALCULATE_SUCCESS: "Calculations updated successfully",
  LOADING: "Loading...",
  PREV: "Previous",
  NEXT: "Next",
  DAY: "Day",
  WEEK: "Week",

  SEARCH_HINT: {
    NUMBER_OR_ESTABLISHMENT: "Number or establishment",
    CASH_REGISTER_READING: "Establishment, cafeteria or register",
    PRODUCT_NAME: "Product name",
    PRODUCT: "Product: name, code or SKU",
    PRODUCT_WITH_SUPPLIER_CODE: "Product: name, code, SKU or supplier code",
    PRODUCT_NAME_OR_SKU: "Product: name or SKU",
    SUPPLIER_PRODUCT: "Product, supplier code or supplier",
    NAME: "Name",
    NAME_OR_CODE: "Name or code",
    NAME_OR_DESCRIPTION: "Name or description",
    CODE_NAME_OR_DESCRIPTION: "Code, name or description",
    CONTACT: "Name, company, email or phone",
    PERSON: "Name, email or phone",
    ESTABLISHMENT: "Name, address, city, email or phone",
    ESTABLISHMENT_NAME: "Establishment name",
    SUPPLIER: "Name, email, phone or tax number",
    SUPPLY_RULE: "Rule, warehouse or supplier",
    TAX: "Name, label or tax number",
    OPTION: "Option or value",
    LOG: "Type, description or details",
    FILE: "Name, path or description",
    FILE_OR_FOLDER: "File or folder",
    DOCUMENT: "Number or description",
    SALES_ORDER: "Number, event or description",
    RESELLER_INVOICE: "Number, customer or description",
    STOCK_MOVEMENT: "Source or destination warehouse",
    CODE: "Code",
    ANY_COLUMN: "Text in any column",
  },
  FILTER_ALL: {
    PRODUCTION_ESTABLISHMENTS: "All productions",
    SATELLITE_ESTABLISHMENTS: "All satellites",
    SOURCES: "All sources",
    DESTINATIONS: "All destinations",
  },
};
